/**
 * A partner licence's state as the site-admin UI shows it. Mirrors
 * `Partner.is_license_active` (backend org/models.py): a licence is usable only
 * when its status is active AND it hasn't passed its expiry date — so an
 * "active" partner whose licence has lapsed reads "Expired", not "Active".
 */
export function partnerStatus(partner) {
    if (partner?.is_license_active) {
        return { label: 'Active', color: 'success' }
    }
    if (partner?.status === 'active') {
        return { label: 'Expired', color: 'warning' }
    }
    const status = partner?.status || 'inactive'
    return {
        label: status.charAt(0).toUpperCase() + status.slice(1),
        color: 'default'
    }
}
